import { Component, Element, Event, EventEmitter, h, Method, State, Prop } from '@stencil/core';
import { IReductionCardFTO } from '../../api/Ticketshop';
import {rootUrl} from "../../helpers/utils";
import { i18n } from '../../utils/I18n';
import { SelectedUser } from '../nj-passangers/nj-passangers';

@Component({
	tag: 'nj-challenged-options',
	styleUrl: 'nj-challenged-options.scss',
	shadow: true,
})
export class NjChallengedOptions {

    @Element() el: HTMLElement;

	@State() user: SelectedUser;
	@State() maxReachdObjects: boolean;
	@State() maxReachedPersons: boolean;
	@State() selectedCards: number[] = [];
	@State() isWheelchairSelected: boolean = false;
	@State() isAttendantSelected: boolean = false;
	@State() isDogSelected: boolean = false;

	@Prop() cards: IReductionCardFTO[] = [];

    @Event() passengerOptionsChanged: EventEmitter;

    @Method()
    async setUserAndLimits(user: SelectedUser, maxReachedObjects: boolean, maxReachedPersons: boolean) {
        this.user = user;
		this.maxReachdObjects = maxReachedObjects;
		this.maxReachedPersons = maxReachedPersons;

		this.selectedCards = [...this.user.cards];
		this.isWheelchairSelected = this.user.njChallengedOptions?.wheelchair;
		this.isAttendantSelected = this.user.njChallengedOptions?.attendant;
		this.isDogSelected = this.user.njChallengedOptions?.dog;

		if (!this.user.njChallengedOptions) this.user.njChallengedOptions = {};
    }

	selectCard(card: IReductionCardFTO) {
		if (this.selectedCards.includes(card.code)) {
			const i = this.user.cards.indexOf(card.code);
			if (i !== -1) this.user.cards.splice(i, 1);

			const j = this.user.njCards.findIndex(njCard => {
				return njCard.code === card.code
			});
			if (j !== -1) this.user.njCards.splice(j, 1);
		} else {
			this.user.cards.push(card.code);
			this.user.njCards.push(card);
		}

		this.selectedCards = [...this.user.cards];
		this.passengerOptionsChanged.emit(this.user);
		this.hideDialog();
	}

	selectWheelchair() {
		if (this.maxReachdObjects && !this.isWheelchairSelected) return;

		this.user.njChallengedOptions.wheelchair = !this.user.njChallengedOptions?.wheelchair;
		this.isWheelchairSelected = this.user.njChallengedOptions?.wheelchair;
		this.passengerOptionsChanged.emit(this.user);
		this.hideDialog();
	}

	selectDog() {
		if (this.maxReachdObjects && !this.isDogSelected) return;

		this.user.njChallengedOptions.dog = !this.user.njChallengedOptions?.dog;
		this.isDogSelected = this.user.njChallengedOptions?.dog;
		this.passengerOptionsChanged.emit(this.user);
		this.hideDialog();
	}

	selectAttendant() {
		if (this.maxReachedPersons && !this.isAttendantSelected) return;

		this.user.njChallengedOptions.attendant = !this.user.njChallengedOptions?.attendant;
		this.isAttendantSelected = this.user.njChallengedOptions?.attendant;
		this.passengerOptionsChanged.emit(this.user);
		this.hideDialog();
	}

	hideDialog() {
		(this.el.parentElement as HTMLNjDialogElement).hide();
	}

	render() {
		return (
			<div class="challenged-options">
				<h3>{i18n.getMessage('challengedOptions.title', 'Reisen mit Behinderung')}</h3>

				<ul>
					{this.cards.map((card) => {
						return (
							<li>
								<button
									aria-pressed={this.selectedCards.includes(card.code)}
									onClick={() => this.selectCard(card)}
								>
									<card-icon class="card-icon" /> {i18n.getMessage('ts.reductionCard.name.' + card.code, 'Karte ' + card.code, null, card.cardName)}
									{this.selectedCards.includes(card.code) ? <check-icon /> : null}
								</button>
							</li>
						)
					})}
					<li>
						<button
							aria-pressed={this.isWheelchairSelected}
							disabled={this.maxReachdObjects && !this.isWheelchairSelected}
							onClick={() => this.selectWheelchair()}
						>
							<card-icon class="card-icon" />
							{i18n.getMessage('challengedOptions.wheelchair', 'Ein Rollstuhlplatz wird benötigt')}
							{this.isWheelchairSelected ? <check-icon /> : null}
						</button>
						<p>
							{i18n.getMessage('challengedOptions.wheelchair.description')}
						</p>
						<p>
							<a href={`${rootUrl()}/${i18n.getLang()}/komfortkategorien/spezialabteile/rollstuhlabteil`} target="_blank">
								{i18n.getMessage('challengedOptions.wheelchair.link')}
							</a>
						</p>
					</li>
					<li>
						<button
							aria-pressed={this.isAttendantSelected}
							disabled={this.maxReachedPersons && !this.isAttendantSelected}
							onClick={() => this.selectAttendant()}
						>
							<card-icon class="card-icon" />
							{i18n.getMessage('challengedOptions.attendant', 'Eine Begleitperson reist mit')}
							{this.isAttendantSelected ? <check-icon /> : null}
						</button>
						<p>
							{i18n.getMessage('challengedOptions.attendant.description')}
						</p>
					</li>
					<li>
						<button
							aria-pressed={this.isDogSelected}
							disabled={this.maxReachdObjects && !this.isDogSelected}
							onClick={() => this.selectDog()}
						>
							<card-icon class="card-icon" />
							{i18n.getMessage('challengedOptions.dog', 'Ein Assistenzhund reist mit')}
							{this.isDogSelected ? <check-icon /> : null}
						</button>
						<p>
							{i18n.getMessage('challengedOptions.dog.description')}
						</p>
					</li>
				</ul>
          </div>
		);
	}

}
